module.exports = __webpack_public_path__ + "static/board-members-ie-74bb70ddfbfd7537c3702f5a80dfecdd.png";